import { render, staticRenderFns } from "./BudgetCharts.vue?vue&type=template&id=ab0b543a&scoped=true&"
import script from "./BudgetCharts.vue?vue&type=script&lang=js&"
export * from "./BudgetCharts.vue?vue&type=script&lang=js&"
import style0 from "./BudgetCharts.vue?vue&type=style&index=0&id=ab0b543a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0b543a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
